import {FunctionalComponent, h} from "@stencil/core";

interface TrustcaptchaProps{
  currentTheme: 'light' | 'dark',
  trustcaptchaUrl: string,
  translation: any,
}

export const TrustcaptchaText: FunctionalComponent<TrustcaptchaProps> = ({ currentTheme, trustcaptchaUrl, translation}) => (
  <a class='text-xs text-right text-blue-500 hover:text-blue-500 hover:underline font-bold' href={trustcaptchaUrl} target='_blank' role="link" aria-label={translation.srTrustcaptcha}>TRUST
    <span class={{'text-gray-700': currentTheme === 'light', 'text-white': currentTheme === 'dark'}}>CAPTCHA</span>
  </a>
)

interface PrivacyProps {
  privacyUrl: string,
  translation: any,
}

export const PrivacyText: FunctionalComponent<PrivacyProps> = ({ privacyUrl, translation }) => (
  <a
    class={{'text-xs text-right hover:text-blue-500 hover:underline': true}} href={privacyUrl} target='_blank' role="link" aria-label={translation.srPrivacy}>{translation.endPrivacyPolicy}
  </a>
)

interface SpinnerProps {
  size: number,
  stroke: number,
}

export const SpinnerIcon: FunctionalComponent<SpinnerProps> = ({size, stroke}) => (
  <svg class="spinner" viewBox="0 0 50 50" width={size} height={size}>
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width={stroke}></circle>
  </svg>
);

interface IconProps {
  size: number,
}

export const CheckIcon: FunctionalComponent<IconProps> = ({ size }) => (
  <div class='text-green-500'>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={size} height={size}>
      <path fill-rule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clip-rule="evenodd"/>
    </svg>
  </div>
)

export const ErrorIcon: FunctionalComponent<IconProps> = ({ size }) => (
  <svg height={size} version="1.1" width={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(0 -1028.4)">
      <path d="m22 12c0 5.523-4.477 10-10 10-5.5228 0-10-4.477-10-10 0-5.5228 4.4772-10 10-10 5.523 0 10 4.4772 10 10z" fill="#c0392b" transform="translate(0 1029.4)"/>
      <path d="m22 12c0 5.523-4.477 10-10 10-5.5228 0-10-4.477-10-10 0-5.5228 4.4772-10 10-10 5.523 0 10 4.4772 10 10z" fill="#e74c3c" transform="translate(0 1028.4)"/>
      <path d="m7.0503 1037.8 3.5357 3.6-3.5357 3.5 1.4142 1.4 3.5355-3.5 3.536 3.5 1.414-1.4-3.536-3.5 3.536-3.6-1.414-1.4-3.536 3.5-3.5355-3.5-1.4142 1.4z" fill="#c0392b"/>
      <path d="m7.0503 1036.8 3.5357 3.6-3.5357 3.5 1.4142 1.4 3.5355-3.5 3.536 3.5 1.414-1.4-3.536-3.5 3.536-3.6-1.414-1.4-3.536 3.5-3.5355-3.5-1.4142 1.4z" fill="#ecf0f1"/>
    </g>
  </svg>
)

export const SpeakerOnIcon: FunctionalComponent<IconProps> = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width={1.5} stroke="currentColor" width={size} height={size}>
    <path stroke-linecap="round" stroke-linejoin="round"
          d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"/>
  </svg>
)

export const SpeakerOffIcon: FunctionalComponent<IconProps> = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width={1.5} stroke="currentColor" width={size} height={size}>
    <path stroke-linecap="round" stroke-linejoin="round"
          d="M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"/>
  </svg>
)

export const XMarkIcon: FunctionalComponent<IconProps> = ({size}) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width={1.5} stroke="currentColor" width={size} height={size}>
    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
  </svg>
)

export const LogoIcon: FunctionalComponent<IconProps> = ({size}) => (
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 428.2 428.2" aria-hidden="true">
    <path d="M393.8,110.2c-0.5-11.3-0.5-22-0.5-32.7c0-8.5-6.9-15.4-15.4-15.4c-64,0-112.6-18.4-153.1-57.9
                      c-6.1-5.6-15.4-5.6-21.5,0c-40.4,39.4-89.1,57.8-153.1,57.9c-8.5,0-15.4,6.9-15.4,15.4c0,10.7,0,21.5-0.5,32.7
                      c-2,107.5-5.1,255,174.6,316.9l5.1,1l5.1-1C398.4,365.2,395.8,218.2,393.8,110.2z M202.2,258.9c-0.2,0.2-0.5,0.4-0.7,0.7
                      c-3,2.4-6.4,3.8-10.4,3.8h-0.5c-4.1,0-8.2-2-10.8-5.1l-39.5-43.8c-4.4-4.9-4-12.5,0.9-16.9l5.2-4.6c4.9-4.4,12.4-3.9,16.8,0.9
                      l21.2,23.5c4.5,5,12.2,5.3,17.1,0.7l65.3-62.1c4.8-4.6,12.4-4.3,17,0.5l4.7,5c4.5,4.8,4.2,12.3-0.6,16.9L202.2,258.9z"/>
  </svg>
)
